import { render, staticRenderFns } from "./warthOfEgypt.vue?vue&type=template&id=7664c7fe"
import script from "./warthOfEgypt.vue?vue&type=script&lang=js"
export * from "./warthOfEgypt.vue?vue&type=script&lang=js"
import style0 from "./warthOfEgypt.vue?vue&type=style&index=0&id=7664c7fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports